import React from 'react';
import TypographyText from './TypographyText';
import { Link } from 'react-router';
import useColor from '../../../hooks/site/useColor';

export default function TypographyLink({ children, ...props }) {
  const { action } = useColor();
  return (
    <TypographyText
      {...props}
      sx={{ textDecoration: 'underline', cursor: 'pointer', color: action.link, ...props.sx }}>
      {children}
    </TypographyText>
  );
}
